import { useAuth, normalizeUserType } from 'Utils/Hooks/useAuth';

/** 'admin' | 'pending' | 'partner' for the signed-in user. */
export default function useAudience() {
  const { currentAdmin } = useAuth();
  if (normalizeUserType(currentAdmin?.user_type) === 'ADMIN') return 'admin';
  const status = currentAdmin?.account_status;
  return status && status !== 'active' ? 'pending' : 'partner';
}

export const helpBase = (audience) => `${process.env.PUBLIC_URL || ''}${audience === 'admin' ? '/dashboard/help' : '/partner/help'}`;
